var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "member-info-container" },
    [
      !_vm.compact
        ? _c("div", { staticClass: "member-row" }, [
            _c("label", { attrs: { for: "account" } }, [_vm._v("会员账号：")]),
            _c("span", { attrs: { id: "account" } }, [
              _vm._v(_vm._s(_vm.memberInfo.username || "--")),
            ]),
          ])
        : _vm._e(),
      !_vm.compact
        ? _c("div", { staticClass: "member-row" }, [
            _c("label", { attrs: { for: "username" } }, [_vm._v("会员id：")]),
            _c("span", { attrs: { id: "username" } }, [
              _vm._v(_vm._s(_vm.memberInfo.uid || "--")),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "member-row member-row-status" },
        [
          _c("el-switch", {
            attrs: {
              "text-color": "#13ce66",
              size: "mini",
              value: _vm.memberInfo.status === 1,
            },
            on: { change: _vm.handleStatusChange },
          }),
          _c(
            "el-button",
            {
              staticClass: "history-btn",
              attrs: { type: "text", size: "mini" },
              on: { click: _vm.openHistoryDialog },
            },
            [_vm._v("查看历史")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.statusDialogTitle,
            visible: _vm.statusDialogVisible,
            width: "450px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.statusDialogVisible = $event
            },
            closed: _vm.handleStatusDialogClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "statusFormRef",
              attrs: {
                model: _vm.statusForm,
                rules: _vm.statusFormRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.statusDialogLabel, prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: _vm.statusDialogPlaceholder,
                    },
                    model: {
                      value: _vm.statusForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.statusForm, "remark", $$v)
                      },
                      expression: "statusForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.statusDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.statusSubmitting,
                  },
                  on: { click: _vm.handleStatusConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog",
          attrs: {
            title: "账号状态历史记录",
            visible: _vm.historyDialogVisible,
            width: "1200px",
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.historyDialogVisible = $event
            },
            opened: _vm.loadHistoryList,
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.historyList,
                border: "",
                stripe: "",
                size: "small",
                "max-height": 400,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "id",
                  label: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "after",
                  label: "操作状态",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "client_desc",
                  label: "备注",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.client_desc || "—"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "created_at",
                  label: "操作时间",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.formatTimestamp(scope.row.created_at))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "operator",
                  label: "操作人",
                  "min-width": "120",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }